module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-container"
  }, [_c('lifebar'), _vm._v(" "), _c('div', {
    staticClass: "question-container"
  }, [_c('transition', {
    attrs: {
      "name": "translateQuestion"
    }
  }, [(_vm.data && _vm.getQuestionsCycle[0]) ? _c('div', [_c('question', {
    attrs: {
      "params": _vm.getQuestionsCycle[0]
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "translateQuestion"
    }
  }, [(_vm.data && _vm.getQuestionsCycle[1]) ? _c('div', [(_vm.data && _vm.getQuestionsCycle[1]) ? _c('question', {
    attrs: {
      "params": _vm.getQuestionsCycle[1]
    }
  }) : _vm._e()], 1) : _vm._e()])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.getShowPopin && _vm.getDataPopin) ? _c('popin', {
    attrs: {
      "params": _vm.getDataPopin
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeIn"
    }
  }, [(_vm.getAnimMoney) ? _c('money') : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4511ab27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/Game.vue
// module id = 84
// module chunks = 0